export const FETCH_PAGE_VISITS_REPORT = "FETCH_PAGE_VISITS_REPORT";
export const FETCH_TEL_LOOKUPS_REPORT = "FETCH_TEL_LOOKUPS_REPORT";
export const FETCH_BOOKINGS_REPORT = "FETCH_BOOKINGS_REPORT";
export const FETCH_BOOKINGS_REPORT_BASED_DOCTOR = "FETCH_BOOKINGS_REPORT_BASED_DOCTOR";
